export { default } from "./DialogContentText.mjs";
export { default as dialogContentTextClasses } from "./dialogContentTextClasses.mjs";
export * from "./dialogContentTextClasses.mjs";